import { createContext, useContext } from "react";

export const DockHeightContext = createContext<number | null>(null);

export function useDockHeight(): number | null {
  return useContext(DockHeightContext);
}
